module.exports = __webpack_public_path__ + "static/media/gyro.39792bab.png";